// The end screens that offer a Share button (sprint 28 item 2): the server counts a click per screen.
export const SHARE_SCREENS = ['reveal', 'shift', 'practice', 'firstMinute'];
